module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = __webpack_require__(1);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _config = __webpack_require__(2);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZutoAnalyticsHelper = function () {
  function ZutoAnalyticsHelper() {
    _classCallCheck(this, ZutoAnalyticsHelper);

    this.Cookies = _jsCookie2.default;
    this.window = typeof window !== 'undefined' ? window : {};
    this.Optimizely = this.window ? this.window.optimizely : {};
  }

  _createClass(ZutoAnalyticsHelper, [{
    key: 'getCookie',
    value: function getCookie(name) {
      var cookie = this.Cookies.get(name);
      return cookie ? cookie : undefined;
    }
  }, {
    key: 'getCookies',
    value: function getCookies() {
      return '?device=' + this.getCookie("Device") + '&session=' + this.getCookie("Session") + '&campaign=' + this.getCookie("zuto_campaign") + '&content=' + this.getCookie("zuto_content") + '&gclid=' + this.getCookie("zuto_gclid") + '&medium=' + this.getCookie("zuto_medium") + '&source=' + this.getCookie("zuto_source") + '&term=' + this.getCookie("zuto_term") + '&app_pub_ref=' + this.getCookie("app_pub_ref");
    }
  }, {
    key: 'getUrl',
    value: function getUrl() {
      var url = encodeURIComponent(this.window && this.window.document && this.window.document.URL);

      return '&url=' + url;
    }

    // maybe update this to be generic so metaData can share

  }, {
    key: 'getDataTags',
    value: function getDataTags(element) {
      var result = {};

      [].forEach.call(element.attributes, function (attr) {
        if (/^data-za-/.test(attr.name)) {
          var camelCaseName = attr.name.substr(8).replace(/-(.)/g, function ($0, $1) {
            return $1.toUpperCase();
          });

          result[camelCaseName] = attr.value;
        }
      });

      return result;
    }
  }, {
    key: 'getMetaTags',
    value: function getMetaTags() {
      var applicationStatus = document.querySelector('meta[name="application_status"]');
      var stringBuilder = applicationStatus ? '&meta.applicationStatus=' + applicationStatus.content : '';

      var metaTags = document.querySelectorAll('meta[name^="za-meta-"]');

      if (!metaTags.length) {
        return stringBuilder;
      }

      for (var metaTag in metaTags) {
        if (!metaTags[metaTag].content) continue;

        var camelCaseName = metaTags[metaTag].name.substr(8).replace(/-(.)/g, function ($0, $1) {
          return $1.toUpperCase();
        });

        stringBuilder += '&meta.' + camelCaseName + '=' + encodeURIComponent(metaTags[metaTag].content);
      }

      return stringBuilder;
    }
  }, {
    key: 'getOptimizelyData',
    value: function getOptimizelyData() {
      var state = this.Optimizely && this.Optimizely.get && this.Optimizely.get('state');

      if (!state) return "";

      var optimizelyData = Object.keys(state.getCampaignStates({ isActive: true })).map(function (id) {
        return state.getDecisionString({ campaignId: id });
      }).join(',');

      return '&optimizelyActivePageExperiments=' + optimizelyData;
    }
  }, {
    key: 'eventHandler',
    value: function eventHandler(evnt) {
      var element = evnt.target;
      var eventType = evnt.type;
      if (element.getAttribute("data-za-event-type") == eventType) {
        this.sendDefaultEvents(element);
      }
    }

    //used for handling event captures

  }, {
    key: 'sendDefaultEvents',
    value: function sendDefaultEvents(element) {
      var link = this.buildDataToAnalyticsUrl();
      var dataTags = this.getDataTags(element);
      var url = this.getUrl();
      link += url;

      for (var property in dataTags) {
        link += '&' + property + '=' + encodeURIComponent(dataTags[property]);
      }

      this.sendRequest("GET", link, false);
    }
  }, {
    key: 'flattenObject',
    value: function flattenObject(obj) {
      var result = {};

      for (var key in obj) {
        if (_typeof(obj[key]) === 'object' && obj[key] !== null) {
          var flatObject = this.flattenObject(obj[key]);

          for (var subKey in flatObject) {
            result[key + '.' + subKey] = flatObject[subKey];
          }
        } else {
          result[key] = obj[key];
        }
      }

      return result;
    }

    //sends object data to zutoanalytics

  }, {
    key: 'sendCustomEvent',
    value: function sendCustomEvent(eventData) {
      var link = this.buildDataToAnalyticsUrl();
      var flatObject = this.flattenObject(eventData);

      Object.keys(flatObject).forEach(function (key) {
        link += '&' + key + '=' + encodeURIComponent(flatObject[key]);
      });

      this.sendRequest("GET", link, false);
    }
  }, {
    key: 'sendCustomEventAsync',
    value: function sendCustomEventAsync(eventData) {
      var link = this.buildDataToAnalyticsUrl();

      for (var key in eventData) {
        link += '&' + key + '=' + encodeURIComponent(eventData[key]);
      }

      this.sendRequest("GET", link, true);
    }

    //internally used for sending requests to ZA

  }, {
    key: 'sendRequest',
    value: function sendRequest(verb, link) {
      var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var xhttp = new XMLHttpRequest();
      xhttp.open(verb, link, async);
      xhttp.withCredentials = true;
      xhttp.send();
    }

    //sends a virtual page request for SPAs

  }, {
    key: 'sendVirtualHttpRequest',
    value: function sendVirtualHttpRequest(url, referrer) {
      var link = _config2.default.Analytics.getUrl() + '/virtualhttprequest?url=' + encodeURIComponent(url) + '&referrer=' + encodeURIComponent(referrer);

      this.sendRequest("GET", link);
    }
  }, {
    key: 'storeViewportInCookies',
    value: function storeViewportInCookies() {
      if (!this.window) {
        return;
      }

      this.Cookies.set("viewport", this.window.screen.width + "x" + this.window.screen.height);
    }
  }, {
    key: 'buildDataToAnalyticsUrl',
    value: function buildDataToAnalyticsUrl() {
      var cookies = this.getCookies();
      var metaData = this.getMetaTags();
      var optimizelyExperimentsData = this.getOptimizelyData();
      var link = _config2.default.Analytics.getUrl() + '/' + cookies + '&httpReferrer=' + encodeURIComponent(document.referrer) + '&TimeSpentOnPage=' + Math.round(performance.now()) + metaData + optimizelyExperimentsData;

      return link;
    }
  }]);

  return ZutoAnalyticsHelper;
}();

exports.default = ZutoAnalyticsHelper;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  Analytics: {
    getUrl: function getUrl() {
      if (window == undefined || window.document == undefined || window.document.URL == undefined) return "https://analytics.uat.zuto.com";
      if (/^((?!\.uat\.).)*?\.zuto\.com/.test(window.document.URL)) return "https://analytics.zuto.com";
      return "https://analytics.uat.zuto.com";
    }
  }
};

/***/ })
/******/ ]);